export default __webpack_public_path__ + "static/media/TessaLovelace.db77ccdf.png";